export default __webpack_public_path__ + "img/76ccb3a19add9c539823e58844243ab6.svg";